export default "__VITE_ASSET__CHDa3CGP__"